export const API_HOST = process.env.NEXT_PUBLIC_API_HOST;
